import { CreatedEventModel, ScheduledEventModel, ServiceScheduleFormModel, } from "../typings/models";
import { ApiHttpService } from "../services/apiHttpService";
import { ApiResponse } from "../typings/interfaces";
import { GOOGLE_SCRIPT_URL } from "../constants/common";
import { objectToFormData } from "../libs/object";

const api = new ApiHttpService();

export const bookService = async (
  form: ServiceScheduleFormModel,
  init?: RequestInit,
): Promise<ApiResponse<CreatedEventModel>> => {
  return await api.post<CreatedEventModel>(
    `${GOOGLE_SCRIPT_URL}`,
    objectToFormData(form),
    init,
  );
};

export const getScheduledEvents = async (
  init?: RequestInit,
): Promise<ApiResponse<ScheduledEventModel[]>> => {
  return await api.get<ScheduledEventModel[]>(
    `${GOOGLE_SCRIPT_URL}`,
    {},
    init,
  );
};